export const TYPE_STRING = "string"
export const POSITIVE_NUMBER = 1
export const WITHOUT_SORTING = "none"
export const SORTING_ASCENDING = "ascending"
export const FIRST_COLUMN_HEADER = 0
export const SORTING_DESCENDING = "descending"
export const ALIGNMENT_RIGHT = "right"
export const ALIGNMENT_LEFT = "left"
export const KEY_COLUMN_HEADER = "column-header"
export const ID_GENERIC_TABLE = "generic-table"
export const SHOW_ARROW_COLUMN = "showArrowColumn"
export const HIDE_ARROW_COLUMN = "hideArrowColumn"
export const VALUE_SORT_ASCENDING = 1
export const VALUE_SORT_DESCENDING = -1
